import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Container, Link, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  footer: {
    marginTop: "auto",
    paddingTop: theme.spacing(4),
  },
  footerInner: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    flexWrap: "wrap",
    padding: 0,
  },
  linkRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
}));

export const FooterText = () => {
  const classes = useStyles();
  const currentYear = new Date().getFullYear();

  return (
    <Box component="footer" className={classes.footer}>
      <Container maxWidth="md" className={classes.footerInner}>
        <Typography variant="caption" color="textSecondary">
          {`Copyright ${currentYear} Hulmify. All rights reserved.`}
        </Typography>
        <Box className={classes.linkRow}>
          <Link
            component={RouterLink}
            to="/privacy-policy"
            color="inherit"
            variant="caption"
          >
            Privacy Policy
          </Link>
          <Link
            component={RouterLink}
            to="/legal"
            color="inherit"
            variant="caption"
          >
            Legal
          </Link>
        </Box>
      </Container>
    </Box>
  );
};
